
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ChartBarsImportServerType enum
 */
class ChartBarsImportServerType {
  /**
   * Initialize enum with a given value
   * @param {ChartBarsImportServerType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ChartBarsImportServerType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ChartBarsImportServerType}
   * @param {!ChartBarsImportServerType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ChartBarsImportServerType)) {
      throw new TypeError('Instance of ChartBarsImportServerType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ChartBarsImportServerType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ChartBarsImportServerType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ChartBarsImportServerType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === ChartBarsImportServerType.TP.value) {
      return 'TP'
    }
    if (this.value === ChartBarsImportServerType.MT4.value) {
      return 'MT4'
    }
    if (this.value === ChartBarsImportServerType.MT5.value) {
      return 'MT5'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ChartBarsImportServerType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ChartBarsImportServerType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ChartBarsImportServerType} Created enum
   */
  static fromObject (other) {
    return new ChartBarsImportServerType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ChartBarsImportServerType.UNKNOWN = new ChartBarsImportServerType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ChartBarsImportServerType.TP = new ChartBarsImportServerType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ChartBarsImportServerType.MT4 = new ChartBarsImportServerType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ChartBarsImportServerType.MT5 = new ChartBarsImportServerType(0 + 3)

export { ChartBarsImportServerType };

/**
 * Fast Binary Encoding ChartBarsImportServerType field model
 */
class FieldModelChartBarsImportServerType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelChartBarsImportServerType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelChartBarsImportServerType}
   * @param {ChartBarsImportServerType=} defaults Default value, defaults is new ChartBarsImportServerType()
   * @returns {!ChartBarsImportServerType} Result value
   */
  get (defaults = new ChartBarsImportServerType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ChartBarsImportServerType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelChartBarsImportServerType}
   * @param {!ChartBarsImportServerType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelChartBarsImportServerType };
